import React from 'react'
import PropTypes from 'prop-types'

const CustomLoader = ({ text }) => (
    <div className="absolute inset-0 w-screen h-screen z-250 flex items-center justify-center">
        <div className="w-full h-full bg-white bg-opacity-95 flex flex-col items-center justify-center">
            <div className="animationLoading play" />
            <span className="text">{text}</span>
        </div>
    </div>
)

CustomLoader.propTypes = {
    text: PropTypes.string,
}

export default CustomLoader
